import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { ProfileService } from 'src/app/_services/profile.service';
import { Response } from 'src/app/models/response';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { ReviewService } from 'src/app/_services/review.service';

@Component({
  selector: 'app-card-come-sta-andando',
  templateUrl: './card-come-sta-andando.component.html',
  styleUrls: ['./card-come-sta-andando.component.css']
})
export class CardComeStaAndandoComponent {
  @Input('data') data: any; //dati in ingresso da expertise.component

  ReviewForm: FormGroup;
  HowIsGoingForm: FormGroup;
  @Output() unsavedChanges = new EventEmitter<boolean>();
  isUser = true;
  isAuthorized = false;
  edit = false;
  is_hidden = false;
  create_review: boolean = false;

  id_review:any;
  reviewData:any;
  userRole!: any;
  how_is_going: any;
  summary: any;
  projects:any;
  review: any;
  currentMonth = new Date().getMonth() + 1;
  user_start_month: any;
  @Input() is_completed: any;


  constructor(private profileService : ProfileService,
    private reviewService : ReviewService) {

    this.HowIsGoingForm = new FormGroup({
      id: new FormControl<string>('',Validators.required),
      how_is_going: new FormControl<string>(''),
    });

    this.ReviewForm = new FormGroup({
      id: new FormControl<string>('',Validators.required),
      review: new FormControl<string>(''),
    });
  }

  async ngOnInit(): Promise<void> {
    this.userRole = await this.profileService.getUserRoleAsync();
    this.userRole = this.userRole.roles[0].name;

    this.profileService.getProfile().subscribe({
      next: (res) => {
        this.user_start_month = res.result.hiring_date;
      }
    });

  }

  changesGuard(change : boolean) {
    this.unsavedChanges.emit(change);
  }

  // funzione per calcolare se l'utente è stato assunto da meno di un mese
  isUserEmployedLessThanOneMonth(): boolean {
    const hiringDate = new Date(this.user_start_month);
    const currentDate = new Date();
    const differenceInMilliseconds = currentDate.getTime() - hiringDate.getTime();
    const differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
    return differenceInDays < 31;
  }



  ngOnChanges(year: SimpleChanges) {
      this.isUser = true;
      this.isAuthorized = false;
      this.getReview();
  }

  sendPartialReview() {
    let is_partial_completed = true;
    let is_draft = false

      this.reviewService.switchPartialReviewCompleted(is_partial_completed,is_draft,this.data.chosenUser,this.data?.current_month,this.data?.current_year).subscribe({
      next: (res: Response<any>) => {
        {
          this.updateReview();
        }
      }
    })
  }
  resetPartialReview(){
    let is_partial_completed = false;
    let is_draft = true
     this.reviewService.switchPartialReviewCompleted(is_partial_completed,is_draft,this.data.chosenUser,this.data.current_month,this.data.current_year).subscribe({
      next: (res: Response<any>) => {
        {
              this.updateReview();
          }
      }
    })
  }

  getReview(month?:any, year?:any, chosenUser?:any){
    chosenUser = this.data?.chosenUser;

    if (this.data?.chosenUser == '') {
        this.isUser = true;
        this.isAuthorized = false;
      }  else{
        this.isUser = false;
        this.isAuthorized = true;
      }

      if (this.data?.current_month != undefined) {
        return this.reviewService.getReview(month = this.data?.current_month, year = this.data?.current_year,chosenUser).subscribe({
          next: (res) => {
            this.reviewData = res?.result

            if (this.reviewData != null) {
              this.review = this.reviewData?.review;

              if(this.reviewData.review_completed_at != null){
                this.data.competenze.is_completed = true
              }

              this.HowIsGoingForm.get('id')?.setValue(this.reviewData?.id);
              this.HowIsGoingForm.get('how_is_going')?.setValue(this.reviewData?.how_is_going);
              this.ReviewForm.get('id')?.setValue(this.reviewData?.id);

              if(this.reviewData.review_completed_at != null || this.isAuthorized == true){
                this.ReviewForm.get('review')?.setValue(this.reviewData?.review);
              }
            }else {
              this.HowIsGoingForm.get('how_is_going')?.setValue('');
              this.ReviewForm.get('review')?.setValue('');
            }
          }
        });
      } else return
  }

  addReview() {
    return this.reviewService.addReview(this.ReviewForm.value.review).subscribe({
      next: () => {
        this.edit = false;
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: 'Review aggiunta',
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })
      },
    });
  }

  updateReview() {
    return this.reviewService.updateReview(this.ReviewForm.value.review, this.ReviewForm.value.id).subscribe({
      next: () => {
        setTimeout(() => {
          this.is_hidden = false;
        }, 1000);
        this.edit = false;
        this.changesGuard(false);
        this.getReview();

        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: 'Review aggiornata',
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })
      }
    });
  }

  addHowIsGoing() {
    return this.reviewService.addHowIsGoing(this.HowIsGoingForm.value.how_is_going, this.data.current_month, this.data.current_year).subscribe({
      next: () => {
        this.changesGuard(false);
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: 'Riepilogo aggiunto',
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })
        this.edit = false;
      }
    });
  }

  updateHowIsGoing() {
    return this.reviewService.updateHowIsGoing(this.HowIsGoingForm.value.how_is_going, this.HowIsGoingForm.value.id).subscribe({
      next: () => {
        this.changesGuard(false);
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: 'Riepilogo aggiornato',
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })
        this.edit = false;
      }
    });
  }

  onEdit() {
    if(this.reviewData) {
      if(this.HowIsGoingForm.value.how_is_going != this.reviewData.how_is_going || this.ReviewForm.value.review != this.reviewData.review)
      {
        this.is_hidden ? null : this.is_hidden = true;
        this.edit = true;
        this.changesGuard(true);
      }
      else this.edit = false;
    }
    else {
      if(this.HowIsGoingForm.value.how_is_going != '' || this.ReviewForm.value.review != '') {
        this.is_hidden ? null : this.is_hidden = true;
        this.edit = true;
        this.create_review = true;
        this.changesGuard(true);
      }
    }
  }
}
